module.exports = __webpack_public_path__ + "img/sie.644863c6.svg";